import React from 'react';
import { Link, useLocation, LinkProps } from 'react-router-dom';

type LocalizedLinkProps = LinkProps;

export const LocalizedLink: React.FC<LocalizedLinkProps> = ({
  to,
  ...rest
}) => {
  const location = useLocation();
  const currentLang = location.pathname.split('/')[1] || 'en';

  let localizedTo: string;
  if (typeof to === 'string') {
    // 既に /en や /ja が付いている場合はそのまま使用し、そうでなければ現在の言語コードを先頭に付与
    localizedTo = /^\/(en|ja)/.test(to) ? to : `/${currentLang}${to}`;
  } else if (typeof to === 'object' && to.pathname) {
    localizedTo = /^\/(en|ja)/.test(to.pathname)
      ? to.pathname
      : `/${currentLang}${to.pathname}`;
  } else {
    localizedTo = '';
  }

  return <Link to={localizedTo} {...rest} />;
};
